// extracted by mini-css-extract-plugin
module.exports = {"container":"_3jp2s","left":"_3EH--","wrapper":"_26TAI","titleWrapper":"_2POlQ","title":"_1_JwX","descriptionWrapper":"dTyOb","description":"EV-c5"};